import { FieldRenderProps } from 'react-final-form';
import styles from './TextInput.module.scss';
import classNames from 'classnames/bind';
import { isValidElement, KeyboardEventHandler, ReactNode } from 'react';
import Icon from '../../Icon/Icon';
import { IconName } from '../../Icon/utils/types';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import '../../../styles/tippy.scss';

const cx = classNames.bind(styles);

interface TextInputProps extends FieldRenderProps<string, HTMLElement> {
  tooltip?: string | ReactNode;
}

const TextInput = (props: TextInputProps) => {
  const {
    input: { value, type, onChange, onBlur },
    meta: { touched, invalid, error },
    placeholder,
    tooltip,
  } = props;

  const onKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (type === 'number' && ['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const tooltipTitle: string | undefined =
    typeof tooltip === 'string' ? tooltip : undefined;
  const tooltipHTML: ReactNode | undefined = isValidElement(tooltip)
    ? tooltip
    : undefined;

  return (
    <div className={cx('text-input__wrapper')}>
      <input
        className={cx('text-input')}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        type={type}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
      />
      {tooltip && (
        <Tooltip
          title={tooltipTitle}
          trigger="mouseenter"
          html={tooltipHTML}
          interactive
        >
          <Icon
            name={IconName.Info}
            width={16}
            height={16}
            className={cx('text-input__info-icon')}
          />
        </Tooltip>
      )}
      <span className={cx('text-input__error')}>
        {touched && invalid && error}
      </span>
    </div>
  );
};

export default TextInput;
